'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');
var Tools_hooks_usePrevious_index = require('../usePrevious/index.js');

var VALIDATE_HOOK;
(function (VALIDATE_HOOK) {
    VALIDATE_HOOK["BLUR"] = "blur";
    VALIDATE_HOOK["CHANGE"] = "change";
    VALIDATE_HOOK["SUBMIT"] = "submit";
})(VALIDATE_HOOK || (VALIDATE_HOOK = {}));

function getDefaultInitialValues(schema, initial) {
    var defaultValues = {};
    Object.keys(schema).forEach(function (key) {
        defaultValues[key] = '';
    });
    return tslib_es6.__assign(tslib_es6.__assign({}, defaultValues), initial);
}
var hasErrors = function (errors) { return (Object.keys(errors || {}) || []).length > 0; };
var ruleInError = function (v) { return !!v; };
var validateSchema = function (schema, values, touched) {
    if (touched === void 0) { touched = {}; }
    var errorsReport = {};
    var validatedReport = {};
    var validateRule = function (rule, value) {
        if (rule.validate(value, values, schema)) {
            return false;
        }
        return rule.message || true;
    };
    var touchedFields = Object.keys(touched);
    var schemaFields = Object.keys(schema);
    var fields = touchedFields.length ? touchedFields : schemaFields;
    fields.forEach(function (fieldKey) {
        var fieldRules = schema[fieldKey] || [];
        var fieldValue = values[fieldKey];
        var fieldErrors = fieldRules.map(function (rule) { return validateRule(rule, fieldValue); }).filter(ruleInError);
        if (fieldErrors && fieldErrors.length) {
            errorsReport[fieldKey] = fieldErrors;
        }
        else {
            validatedReport[fieldKey] = fieldValue;
        }
    });
    return {
        validated: validatedReport,
        errors: errorsReport,
    };
};
var getInputEntry = function (element) { return [
    element.name,
    element.type === 'checkbox' ? element.checked : element.value,
]; };
var defaultConfig = {
    customErrors: {},
    isFetching: false,
    validateOn: [VALIDATE_HOOK.SUBMIT],
};
function useForm(config) {
    var _a = tslib_es6.__assign(tslib_es6.__assign({}, defaultConfig), config), schema = _a.schema, initialValues = _a.initialValues, customErrors = _a.customErrors, isFetching = _a.isFetching, validateOn = _a.validateOn, onSubmitValid = _a.onSubmitValid;
    var _b = React.useState(initialValues), values = _b[0], setValues = _b[1];
    var _c = React.useState({}), touched = _c[0], setTouched = _c[1];
    var _d = React.useState(customErrors), errors = _d[0], setErrors = _d[1];
    var didFetch = Tools_hooks_usePrevious_index['default'](isFetching) && !isFetching;
    React.useEffect(function () {
        if (didFetch) {
            setErrors(errors);
        }
    }, [didFetch, errors]);
    var handleValueChange = function (name, value) {
        var _a;
        setValues(tslib_es6.__assign(tslib_es6.__assign({}, values), (_a = {}, _a[name] = value, _a)));
        var errorHolder = tslib_es6.__assign({}, errors);
        if (errorHolder[name]) {
            delete errorHolder[name];
            setErrors(errorHolder);
        }
        var touchedHolder = tslib_es6.__assign({}, touched);
        if (touchedHolder[name]) {
            delete touchedHolder[name];
            setTouched(touchedHolder);
        }
    };
    var testValidation = function (hook, newTouched) {
        var toValidate = hook === VALIDATE_HOOK.BLUR ? newTouched : {};
        var err = validateSchema(schema, values, toValidate).errors;
        setErrors(err);
        return err;
    };
    var hookValidation = function (hook, newTouched) {
        if (newTouched === void 0) { newTouched = {}; }
        if (validateOn.includes(hook)) {
            return testValidation(hook, newTouched);
        }
        return errors;
    };
    var onChange = function (event) {
        var target = event.target;
        var _a = getInputEntry(target), name = _a[0], value = _a[1];
        handleValueChange(name, value);
        hookValidation(VALIDATE_HOOK.CHANGE);
    };
    var onBlur = function (event) {
        var target = event.target;
        var _a = getInputEntry(target), name = _a[0], value = _a[1];
        var newTouched = touched;
        if (!touched[name]) {
            newTouched[name] = true;
            setTouched(newTouched);
        }
        if (value && value !== values[name]) {
            handleValueChange(name, value);
        }
        hookValidation(VALIDATE_HOOK.BLUR, newTouched);
    };
    var onSubmit = function (event) {
        event.preventDefault();
        var currentErrors = hookValidation(VALIDATE_HOOK.SUBMIT);
        if (!hasErrors(currentErrors)) {
            onSubmitValid(values);
        }
    };
    var validateAll = function (filter) {
        if (filter === void 0) { filter = {}; }
        return testValidation(VALIDATE_HOOK.BLUR, filter);
    };
    var resetFormValue = function () {
        setValues(getDefaultInitialValues(schema, initialValues));
        setErrors(customErrors || {});
        setTouched({});
    };
    var isValid = React.useCallback(function (name) {
        var error = errors[name.toString()];
        var isNotValidated = error === undefined;
        if (isNotValidated) {
            return undefined;
        }
        return !error && values[name] !== undefined;
    }, [errors, values]);
    var isValidated = React.useCallback(function (name) { return errors[name.toString()] !== undefined; }, [errors]);
    return {
        touched: touched,
        values: values,
        errors: errors,
        onChange: onChange,
        onBlur: onBlur,
        onSubmit: onSubmit,
        resetFormValue: resetFormValue,
        setValues: setValues,
        isValid: isValid,
        isValidated: isValidated,
        validateAll: validateAll,
        setTouched: setTouched,
        setErrors: setErrors,
    };
}

exports.default = useForm;
exports.validateSchema = validateSchema;
//# sourceMappingURL=index.js.map
